export { PLUGIN_KEY, PLUGIN_PRIORITY, Filters } from "./filters.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/filters/index.mjs
// module id = 1410
// module chunks = 1